import { render } from "./TechItsTrustedCompaniesComp.vue?vue&type=template&id=5a39407e&scoped=true"
import script from "./TechItsTrustedCompaniesComp.vue?vue&type=script&lang=js"
export * from "./TechItsTrustedCompaniesComp.vue?vue&type=script&lang=js"

import "./TechItsTrustedCompaniesComp.vue?vue&type=style&index=0&id=5a39407e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a39407e"]])

export default __exports__